import { RouteConfig } from "vue-router";

export const RTeammatesBrowse: RouteConfig = {
  path: "",
  name: "Teammates",
  component: () =>
    import(
      /* webpackChunkName: "teammates-browse" */
      "./VTeammatesBrowse.vue"
    ),
  meta: {
    title: "Teammates",
  },
};
